import { render, staticRenderFns } from "./MyContentResults.vue?vue&type=template&id=4d27f94e&"
import script from "./MyContentResults.vue?vue&type=script&lang=js&"
export * from "./MyContentResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports